import reset from './base.scss';
import whatchForHover from './../js/whatch-for-hover';

whatchForHover();

export default reset;
